import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Slug {
  public static of(stringToNormalize: string) {
    return stringToNormalize.normalize('NFD')
      .trim()
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ [-]*[ ]*/g, '-')
      .replace(/[_\s]/g, '-')
      .replace(/[^a-zA-Z0-9 -]/g, '')
      .replace(/[\-]+/g, '-')
      .toLowerCase();
  }
}
